module.exports = __webpack_public_path__ + "static/media/upload-solid.cb3362db.svg";